module.exports = __webpack_public_path__ + "img/logo_tx.8c57778e.png";